export default "__VITE_ASSET__BgRuvl6k__"